// Generated by scripts/update-seeq-icons.js from src/svg/seeq/usage.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcUsage = {
  prefix: 'fak',
  iconName: 'usage' as IconName,
  icon: [
    1307,
    1024,
    [],
    'e971',
    'M1132.9 675.4c-0.1 0-0.3 0-0.5 0-32 0-61.9 8.9-87.4 24.4l0.8-0.4-244-322.5c42.9-39 69.7-95 69.7-157.2 0-0.6 0-1.3 0-1.9l0 0.1c0-120.3-97.5-217.9-217.9-217.9s-217.9 97.5-217.9 217.9v0c0 0.5 0 1.2 0 1.8 0 62.3 26.8 118.3 69.6 157.1l0.2 0.1-244.1 322.5c-24.7-15.1-54.7-24-86.6-24-0.2 0-0.3 0-0.5 0h0c-96.3 0-174.3 78-174.3 174.3s78 174.3 174.3 174.3c96.3 0 174.3-78 174.3-174.3v0c0-0.3 0-0.7 0-1.1 0-48.3-20-91.9-52.2-123l-0.1-0.1 244-322.4c26 16.8 57.2 27.8 90.8 30.4l0.7 0.1v241.8c-86.4 11.2-152.5 84.3-152.5 172.9 0 96.3 78 174.3 174.3 174.3s174.3-78 174.3-174.3c0-88.6-66.1-161.7-151.6-172.8l-0.9-0.1v-241.8c34.2-4.6 65.1-15.3 92.7-31.2l-1.2 0.7 244 322.4c-32.3 31.1-52.3 74.8-52.3 123.1 0 0.4 0 0.8 0 1.2v-0.1c0 96.3 78 174.3 174.3 174.3s174.3-78 174.3-174.3c0-96.3-78-174.3-174.3-174.3v0z',
  ],
} satisfies IconDefinition;
